import { useQuery } from 'react-query'
import {
  apiPostRelatedDTCsRequest,
  apiPostRelatedCircuitsRequest,
} from '../api/circuit-dtcs-api'

export const useRelatedDTCs = ({ makeModelId, circuits }) => {
  const {
    status,
    data: dtcs,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    ['circuit-dtcs-by-circuits', makeModelId, ...circuits],
    async () => {
      const result = await apiPostRelatedDTCsRequest({ makeModelId, circuits })
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!makeModelId && !!circuits.length,
    },
  )

  return {
    status,
    dtcs,
    error,
    isLoading,
    isFetching,
    isError,
    isSuccess,
  }
}

export const useRelatedCircuits = ({ makeModelId, dtcs }) => {
  const {
    status,
    data: circuits,
    error,
    isFetching,
    isLoading,
    isError,
    isSuccess,
  } = useQuery(
    ['circuit-dtc-by-dtcs', makeModelId, dtcs],
    async () => {
      const result = await apiPostRelatedCircuitsRequest({ makeModelId, dtcs })
      return result.data
    },
    {
      refetchOnWindowFocus: false,
      enabled: !!makeModelId && !!dtcs.length,
    },
  )

  return {
    status,
    circuits,
    error,
    isLoading,
    isFetching,
    isError,
    isSuccess,
  }
}
